// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminLayout_layout__omW1X {
    background-color: #1f1f1f;
    width: 100%;
    height: 100vh;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: fixed;
    top: 47px;
}
    `, "",{"version":3,"sources":["webpack://./src/Components/AdminPages/AdminLayout/AdminLayout.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;IACf,SAAS;AACb","sourcesContent":[".layout {\n    background-color: #1f1f1f;\n    width: 100%;\n    height: 100vh;\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    position: fixed;\n    top: 47px;\n}\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `AdminLayout_layout__omW1X`
};
export default ___CSS_LOADER_EXPORT___;
